import { gql } from '@apollo/client';

export const ADD_SUBMISSION_REVIEW = gql`
  mutation AddSubmissionReview($input: AddSubmissionReviewInput!) {
    addSubmissionReview(input: $input) {
      reviewId
      submissionId
      authorId
      authorRole
      comment
      mediaUrls
      round
      publishedAt
      createAt
    }
  }
`;

export const PUBLISH_SUBMISSION_REVIEWS = gql`
  mutation PublishSubmissionReviews($submissionId: String!) {
    publishSubmissionReviews(submissionId: $submissionId) {
      submissionId
      submissionStatus
      latestReviewPublishedAt
      reviewFlowEnabled
      resubmittedAt
    }
  }
`;

export const WITHDRAW_ASSIGNMENT = gql`
  mutation WithdrawAssignment($submissionId: String!) {
    withdrawAssignment(submissionId: $submissionId) {
      submissionId
      submissionStatus
      resubmittedAt
      reviewFlowEnabled
      latestReviewPublishedAt
    }
  }
`;

export const SUBMIT_ASSIGNMENT = gql`
  mutation SubmitAssignment($submissionId: String!) {
    submitAssignment(submissionId: $submissionId) {
      submissionId
      submissionStatus
      resubmittedAt
      reviewFlowEnabled
      latestReviewPublishedAt
    }
  }
`;

export const SUBMISSION_REVIEWS = gql`
  query SubmissionReviews($submissionId: String!) {
    submissionReviews(submissionId: $submissionId) {
      reviewId
      submissionId
      authorId
      authorRole
      comment
      mediaUrls
      round
      publishedAt
      createAt
    }
  }
`;

export type SubmissionReviewItem = {
  reviewId: string;
  submissionId: string;
  authorId: string;
  authorRole: string;
  comment: string;
  mediaUrls: string[];
  round: number;
  publishedAt?: string | null;
  createAt?: string | null;
};
